// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Space,
  Switch,
  Table,
  TableColumnProps,
  Radio,
  Select
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';

const FormItem = Form.Item;
const Option = Select.Option;

interface UmsMenu {
  id?: number;
  parentId: number;
  title: string;
  name: string;
  icon?: string;
  hidden: number;
  sort: number;
  level?: number;
  path?: string;
  hasChild?: boolean;
}

interface MenuNode {
  id: number;
  title: string;
  children?: MenuNode[];
  [key: string]: any;
}

function MenuManagement() {
  const [form] = Form.useForm<UmsMenu>();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<UmsMenu[]>([]);
  const [loading, setLoading] = useState(false);
  const [parentMenuList, setParentMenuList] = useState<MenuNode[]>([]);
  const [currentParentId, setCurrentParentId] = useState<number>(0);
  const formRef = useRef<any>({});

  // 获取数据列表
  const getList = (reset?: boolean, parentId?: number, parentMenu?: UmsMenu | null) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(20);
    }

    const searchParentId = parentId !== undefined ? parentId : currentParentId;
    const params = {
      pageNum: reset ? 1 : pageNum,
      pageSize: reset ? 20 : pageSize
    };

    get(`/menu/list/${searchParentId}`, params)
      .then((res: any) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          const { list, total: totalCount } = data || {};
          // 如果是在查看下级菜单（searchParentId !== 0），将一级菜单添加到列表顶部
          let finalList = list || [];
          if (searchParentId !== 0 && parentMenu) {
            finalList = [parentMenu, ...finalList];
          }
          setTotal(totalCount || 0);
          setDataList(finalList);
        } else {
          Message.error(message || '获取数据失败!');
        }
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 获取菜单树（用于选择上级菜单）
  const getMenuTree = () => {
    get('/menu/treeList')
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          // 只保留一级菜单（level === 0）
          const levelOneMenus = (data || []).filter((menu: MenuNode) => menu.level === 0)
            .map((menu: MenuNode) => ({
              ...menu,
              children: undefined,
            }));
          setParentMenuList(levelOneMenus);
        }
      })
      .catch(() => {
        Message.error('获取菜单树失败!');
      });
  };

  // 递归构建菜单选项
  const buildMenuOptions = (nodes: MenuNode[], level: number = 0): any[] => {
    const options: any[] = [];
    nodes.forEach(node => {
      const prefix = '  '.repeat(level);
      options.push({
        value: node.id,
        label: `${prefix}${node.title}`
      });
      if (node.children && node.children.length > 0) {
        options.push(...buildMenuOptions(node.children, level + 1));
      }
    });
    return options;
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: '编号',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '菜单名称',
      dataIndex: 'title',
      width: 150
    },
    {
      title: '菜单级数',
      dataIndex: 'level',
      width: 100,
      render: (text) => {
        const levelMap: Record<number, string> = {
          0: '一级',
          1: '二级',
          2: '三级'
        };
        return levelMap[text] || `第${text + 1}级`;
      }
    },
    {
      title: '页面路径',
      dataIndex: 'path',
      width: 120
    },
    {
      title: '前端图标',
      dataIndex: 'icon',
      width: 120,
      render: (text) => text || '-'
    },
    {
      title: '是否显示',
      dataIndex: 'hidden',
      width: 100,
      render: (text, record) => (
        <Switch
          checked={text === 0}
          onChange={val => handleHiddenChange(val, record)}
        />
      )
    },
    {
      title: '排序',
      dataIndex: 'sort',
      width: 80
    },
    {
      title: '设置',
      dataIndex: 'settings',
      width: 100,
      render: (_, record: UmsMenu) => {

        // 如果当前记录是父菜单（在查看下级时显示在顶部），显示"返回上级"按钮
        if (currentParentId !== 0 && record?.level === 0) {
          return (
            <Button
              type="text"
              onClick={handleReset}
              loading={loading}
            >
              返回上级
            </Button>
          );
        }
        
        // 如果没有子菜单，不显示"查看下级"按钮
        if (record?.hasChild) {
          return (
            <Button
              type="text"
              onClick={() => handleViewSubMenus(record)}
              loading={loading}
            >
              查看下级
            </Button>
          );
        }

      }
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 150,
      render: (_, record: UmsMenu) => (
        <Space>
          <Button
            type="text"
            onClick={() => edit(record)}
            loading={loading}
          >
            编辑
          </Button>
          <Popconfirm
            focusLock
            title="提示"
            content="是否要删除该菜单?"
            onOk={() => del(record)}
          >
            <Button
              type="text"
              status="danger"
              loading={loading}
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  // 处理显示状态变更
  const handleHiddenChange = (val: boolean, record: UmsMenu) => {
    if (!record.id) {
      Message.error('菜单ID不存在！');
      return;
    }
    setLoading(true);
    const hidden = val ? 0 : 1;
    get(`/menu/updateHidden/${record.id}`, { hidden })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 查看下级菜单
  const handleViewSubMenus = (record: UmsMenu) => {
    if (!record.id) {
      Message.error('菜单ID不存在！');
      return;
    }
    setCurrentParentId(record.id);
    // 直接传递 record 作为 parentMenu 参数，避免依赖状态更新时机
    getList(true, record.id, record);
  };

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setCurrentParentId(0);
    setPageNum(1);
    setPageSize(20);
    getList(true, 0);
  };

  // 新增菜单
  const add = () => {
    formRef.current = {};
    form.resetFields();
    getMenuTree();
    setVisible(true);
    // 在 Modal 打开后设置表单值，确保值能正确设置
    form.setFieldsValue({
      parentId: 0,
      hidden: 0,
      sort: 0
    });
  };

  // 删除菜单
  const del = (record: UmsMenu) => {
    if (!record.id) {
      Message.error('菜单ID不存在！');
      return;
    }
    setLoading(true);

    post(`/menu/delete/${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          // getList();
          handleReset()
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑菜单
  const edit = (record: UmsMenu) => {
    formRef.current = record;
    form.setFieldsValue({
      ...record,
      parentId: record.parentId || 0,
      hidden: record.hidden !== undefined ? record.hidden : 0
    });
    getMenuTree();
    setVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      setLoading(true);
      const data = {
        ...formRef.current,
        ...values,
        parentId: values.parentId || 0
      };

      if (formRef.current.id) {
        // 更新菜单
        post(`/menu/update/${formRef.current.id}`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('编辑成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        // 创建菜单
        post(`/menu/create`, data)
          .then((res: any) => {
            const { code, message } = res || {};
            if (code === 200) {
              Message.success('新增成功！');
              getList();
              editCancel();
            } else {
              Message.error(message);
            }
          })
          .catch(e => {
            Message.error('网络错误!');
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="menu-management table-flex">
      <div className="filter-section">
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <Button type="primary" onClick={add} loading={loading}>
            添加
          </Button>
        </Form>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={dataList}
        className="table-scroll"
        pagination={{
          sizeCanChange: true,
          pageSize,
          total,
          showTotal: true,
          current: pageNum,
          onChange: (num, size) => {
            setPageNum(num);
            if (size && size !== pageSize) {
              setPageSize(size);
            }
          }
        }}
        scroll={{ y: '100%', x: '100%' }}
        loading={loading}
      />

      {/* 新增/编辑菜单弹框 */}
      <Modal
        title={formRef.current.id ? '编辑菜单' : '添加菜单'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <FormItem
            label="菜单名称:"
            field="title"
            rules={[{ required: true, message: '请输入菜单名称' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="上级菜单:" field="parentId">
            <Select
              placeholder="无上级菜单"
              allowClear
              onChange={(value) => {
                form.setFieldValue('parentId', value || 0);
              }}
            >
              <Option value={0}>无上级菜单</Option>
              {buildMenuOptions(parentMenuList).map(option => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </FormItem>
          <FormItem
            label="前端名称:"
            field="name"
            rules={[{ required: true, message: '请输入前端名称' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem
            label="前端图标:"
            field="icon"
            rules={[{ message: '请输入前端图标' }]}
          >
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem
            label="路径:"
            field="path"
            rules={[{ required: true, message: '请输入路径' }]}
          >
            <Input placeholder="请输入路径，如: /admin" />
          </FormItem>
          <FormItem
            label="是否显示:"
            field="hidden"
            triggerPropName="value"
          >
            <Radio.Group>
              <Radio value={0}>是</Radio>
              <Radio value={1}>否</Radio>
            </Radio.Group>
          </FormItem>
          <FormItem label="排序:" field="sort">
            <Input type="number" placeholder="0" />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default MenuManagement;

